/**
 * File: inventoryList.js
 * Project: educore
 * Created Date: 2019-03-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class InventoryListController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, SchoolLogo, authService, CONSTANTS) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let schoolId = localStorageService.get('school_id')
        $scope.showFilters = false
        $scope.pageSize = 50;
        $scope.totalCount = 0;
        $scope.medicineCount = 0
        $scope.searchWord = undefined
        $scope.errors = {}
        
        /*********** Prototype for pagination: START ******************/
        function inventoryItems() {
            this.loadedPages = {}; //details of loaded pages on scroll
            this.numItems = 0; //total number of items
            this.PAGE_SIZE = $scope.pageSize; //number of items per page
            this.fetchPage_(0);
        };

        //To get the item at the index
        //index -> current index
        inventoryItems.prototype.getItemAtIndex = function(index) {
            //calculate the page number of the given index
            let pageNumber = Math.floor(index / this.PAGE_SIZE);
            let page = this.loadedPages[pageNumber];
            //if page items are loaded
            if (page) {
                return page[index % this.PAGE_SIZE];
            } else if (page !== null) {
                //else fetch the page content. calling method to fetch item from db
                this.fetchPage_(pageNumber);
            }
        };

        //To get the total number of items
        inventoryItems.prototype.getLength = function() {
            return this.numItems;
        };

        //To fetch the items from db
        //pageNumber -> number for which page the items to be fetched
        inventoryItems.prototype.fetchPage_ = function(pageNumber) {
            this.loadedPages[pageNumber] = null;
            //To calculate the page offset(number of items to be skiped)
            let pageOffset = pageNumber * this.PAGE_SIZE;
            let paginationOpts = {
                limit: parseInt(this.PAGE_SIZE),
                skip: parseInt(pageOffset),
            };
            let obj = {
                pagination_options: paginationOpts,
                school_id: schoolId,
                filters: filterObj,
                search_word: $scope.searchWord
            }
            authService.callAPI(MEDICALCONSTANT.API_GET_INVENTORY_LIST, "POST", obj, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    this.numItems = response.result.data.data.count
                    this.totalCount = response.result.data.data.count
                    $scope.medicineCount = response.result.data.data.count
                    this.loadedPages[pageNumber] = response.result.data.data.list
                    $scope.productDetails = response.result.data.data.list
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        };
        $scope.productList = new inventoryItems();
        authService.callAPI(MEDICALCONSTANT.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, (response) => {
            if (response.result && response.result.status && response.result.data.details) {
                let result = response.result.data.details
                $scope.schoolHeader = {
                    'schoolName': result.school_name,
                    'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo)
                }
                convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function(base64Image) {
                    $scope.imgurl1 = base64Image;
                })
            }
        })

        function convertFileToDataURLviaFileReader(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        };

        function getDataUri(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        }

        $scope.generatePdf = (fromDate, toDate, search_type) => {
            let obj = {
                filters: filterObj,
                school_id: schoolId,
                search_word: $scope.searchWord
            }
            authService.callAPI(MEDICALCONSTANT.API_GET_INVENTORY_PDF, "POST", obj, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    $scope.allMedicineList = response.result.data.data
                    let content = [];
                    if (filterObj && filterObj.search_type) {
                        if (filterObj.search_type === 'M')
                            $scope.searchType = "Mfg"
                        else
                            $scope.searchType = "Exp"
                    }
                    if (filterObj && filterObj.category_search)
                        $scope.categorySearch = filterObj.category_search
                    else
                        $scope.categorySearch = "All"
                    content.push({
                        columns: [{
                                width: 70,
                                height: 70,
                                image: $scope.imgurl1
                            },
                            [{
                                alignment: 'center',
                                columns: [{
                                    text: $scope.schoolHeader.schoolName,
                                    style: 'title'
                                }]
                            }, {
                                alignment: 'center',
                                columns: [{
                                    text: "Inventory of Medicine"
                                }]
                            }]
                        ]
                    })
                    content.push({
                        canvas: [{
                            type: 'line',
                            x1: 0,
                            y1: 10,
                            x2: 760,
                            y2: 10,
                            lineWidth: 0.5
                        }]
                    })
                    content.push("\n")
                    if (filterObj && filterObj.exp_start && filterObj.exp_end) {
                        content.push({
                            columns: [
                                [{
                                    columns: [{
                                        text: "Category:" + $scope.categorySearch
                                    }]
                                }, {
                                    columns: [{
                                        text: $scope.searchType + " From:" + filterObj.exp_start.getFullYear() + '-' + (filterObj.exp_start.getMonth() + 1) + '-' + filterObj.exp_start.getDate()
                                    }]
                                }, {
                                    columns: [{
                                        text: $scope.searchType + " To:" + filterObj.exp_end.getFullYear() + '-' + (filterObj.exp_end.getMonth() + 1) + '-' + filterObj.exp_end.getDate()
                                    }]
                                }]
                            ]

                        })
                        content.push({
                            canvas: [{
                                type: 'line',
                                x1: 0,
                                y1: 10,
                                x2: 760,
                                y2: 10,
                                lineWidth: 0.5
                            }]
                        })
                    }
                    content.push("\n")
                    if (filterObj && !filterObj.exp_start && !filterObj.exp_end && filterObj.category_search) {
                        content.push({
                            columns: [
                                [{
                                    columns: [{
                                        text: "Category:" + filterObj.category_search
                                    }]
                                }]
                            ]

                        })
                        content.push({
                            canvas: [{
                                type: 'line',
                                x1: 0,
                                y1: 10,
                                x2: 760,
                                y2: 10,
                                lineWidth: 0.5
                            }]
                        })
                    }
                    content.push("\n")



                    let body = [];
                    let header = [{
                        text: "S.No.",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Product Name",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Category",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Product Type",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Unit(count/ml)",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Unit Price",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Mfg Date",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Exp Date",
                        style: 'tableHeader',
                        alignment: 'center'
                    }, {
                        text: "Batch Id",
                        style: 'tableHeader',
                        alignment: 'center'
                    }]
                    body.push(header)
                    _.each($scope.allMedicineList, function(eachPdt, index) {
                        let sNo = index + 1
                        let mDate = new Date(eachPdt.mfg_date)
                        let eDate = new Date(eachPdt.exp_date)
                        let mfg_date = mDate.getFullYear() + '-' + (mDate.getMonth() + 1) + '-' + mDate.getDate()
                        let exp_date = eDate.getFullYear() + '-' + (eDate.getMonth() + 1) + '-' + eDate.getDate()
                        body.push([sNo, eachPdt.medicine_name, eachPdt.category, eachPdt.medicine_type, eachPdt.remaining_count, eachPdt.price, mfg_date, exp_date, eachPdt.batch_no])
                    })
                    let table = {
                        widths: ['25', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        style: 'tableExample',
                        table: {
                            headerRows: 1,
                            body: body
                        }
                    }

                    content.push(table)

                    var docDefinition = {
                        pageOrientation: 'landscape',
                        content: content,
                        styles: {
                            title: {
                                fontSize: 18,
                                bold: true,
                                alignment: 'center'
                            },
                            sectionTitle: {
                                bold: true,
                                italics: true
                            },
                            boldStyle: {
                                bold: true
                            }
                        }
                    }
                    pdfMake.createPdf(docDefinition).open();
                }
            })
        }
        $scope.backToHtml = () => {
            $scope.pdfData = false
        }
        $scope.addInventory = () => {
            $state.go('inventory')
        }
        var firstClick = false
        $scope.pdfExport = () => { //filter
            $scope.showFilters = true
            firstClick = true
        }
        $scope.refreshFilter = () => {
            $scope.errors = {}
            $scope.exp_start = null
            $scope.exp_end = null
            $scope.showFilters = false
            $scope.search_type = undefined
            $scope.category_search = undefined
            filterObj = {}
            $scope.productList = new inventoryItems();
            firstClick = false
        }
        let filterObj = {}
        $scope.filterOrExp = () => {
            if ($scope.search_type && !$scope.exp_start)
                $scope.errors.exp_start = "Please select from date"
            if ($scope.search_type && !$scope.exp_end)
                $scope.errors.exp_end = "Please select To Date"
            if (($scope.exp_end || $scope.exp_start) && !$scope.search_type)
                $scope.errors.search_type = "Please select Search Type"
            if (($scope.exp_start && $scope.exp_end && $scope.search_type) || $scope.category_search) {
                filterObj = {
                    exp_start: $scope.exp_start,
                    exp_end: $scope.exp_end,
                    search_type: $scope.search_type,
                    category_search: $scope.category_search
                }
                $scope.productList = new inventoryItems();
            }
        }
        $scope.stockDetails = () => {
            $state.go('stockList')
        }
        $scope.searchByName = function() {
            $scope.productList = new inventoryItems();
        }
    }
}
export default InventoryListController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/inventory/inventoryList.js